"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SecurityCommandCenterShield(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 48 48",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F2F4",
    d: "M24 40.75l-11.25-7.454c-1.963-1.3-3.514-2.276-4.774-3.174C1.593 25.576 1.766 16.435 1.5 8.603c7.158.678 14.284-1.542 19.59-6.102L24 0l1.543 1.459c5.5 5.198 6.73 6.135 14.404 7.144 1.206 7.755.86 16.478-5.84 20.565-5.142 3.138-11.545 5.081-15.732 7.855L24 40.749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    fillRule: "evenodd",
    d: "M2.3 9.469c0 7.086-.585 15.673 5.113 19.886 1.346.994 3.108 1.883 5.779 3.653L24 40.168l10.808-7.16c4.133-2.738 6.393-3.717 8.05-5.957 2.956-3.994 2.842-9.4 2.842-14.37V9.463c-7.693.433-15.241-2.255-20.707-7.422l-1.019-.963-2.363 2.03C16.352 7.628 9.371 9.913 2.3 9.47zm-.8.162c0 6.988-.67 15.315 4.693 19.794 1.497 1.25 3.479 2.21 6.557 4.25L24 41.47l11.25-7.796c4.75-3.147 7.145-3.966 8.915-7.003 2.319-3.975 2.335-8.832 2.335-13.434V8.603c-.267.024-.534.043-.8.058-7.497.434-14.847-2.182-20.157-7.202L24 0l-2.91 2.501C15.98 6.891 9.186 9.112 2.3 8.667a26.903 26.903 0 01-.8-.064v1.028z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FA",
    d: "M25.392 44.281A12.886 12.886 0 0111.78 33.097c-.717-5.16 1.83-10.303 6.373-12.842 7.35-4.108 16.18-.373 18.64 7.203a12.821 12.821 0 01-.852 9.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M24.545 37.435l-2.813-1.863c-1.763-1.169-2.812-3.069-2.812-5.095v-2.891c1.79.17 3.57-.386 4.897-1.526l.728-.625.386.365c1.374 1.3 3.296 1.954 5.239 1.786v2.891c0 2.026-1.049 3.926-2.813 5.095l-2.812 1.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M25.355 26.13c-1.598 1.93-2.623 2.305-4.6 2.68v1.667c0 2.243 1.178 3.958 3.148 5.095l1.852.738-1.21 1.125-2.813-1.863c-1.764-1.169-2.813-3.069-2.813-5.095v-2.891c1.943.169 3.865-.487 5.24-1.786l.385-.365.728.625c.027.024.055.048.083.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.515 32.31a.87.87 0 00.866-.875.87.87 0 00-.866-.874.87.87 0 00-.867.874.87.87 0 00.867.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.545 33.746a2.311 2.311 0 100-4.622 2.311 2.311 0 000 4.622zm0 .75a3.061 3.061 0 100-6.122 3.061 3.061 0 000 6.122z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.183 37.435v-3.264h.75v3.264h-.75zM22.133 30.26l-3.418-2.207.407-.63 3.418 2.208-.407.63zM26.956 30.26l3.417-2.207-.407-.63-3.417 2.208.407.63z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    d: "M35.588 37.724a.53.53 0 00.736-.207 13.385 13.385 0 10-10.798 7.168.53.53 0 00.477-.597.566.566 0 00-.61-.488 12.292 12.292 0 119.982-6.627.566.566 0 00.213.751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.973 40.005a.546.546 0 01.771.017l4.132 4.309-4.354 3.546a.546.546 0 11-.69-.846l3.437-2.8-3.313-3.454a.546.546 0 01.017-.772z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87949F",
    fillRule: "evenodd",
    d: "M21.973 40.005a.546.546 0 01.771.017l4.132 4.309-4.354 3.546a.546.546 0 11-.69-.846l3.437-2.8-3.313-3.454a.546.546 0 01.017-.772z",
    clipRule: "evenodd"
  }));
}

SecurityCommandCenterShield.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SecurityCommandCenterShield.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SecurityCommandCenterShield;
exports["default"] = _default;